export const FEATURE_NAME = '@zerops/zerops/feature/token-add-edit-dialog';

export const SUDO_TOKEN_TOOLTIP = 'Sudo mode - can access sensitive data and operations';
